/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Form_Validation_Max_LengthInputs */



/**
* | output |
* | --- |
* | "Maximum length is {max} characters" |
*
* @param {Form_Validation_Max_LengthInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const form_validation_max_length = /** @type {((inputs: Form_Validation_Max_LengthInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Validation_Max_LengthInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Darf höchstens ${i?.max} Zeichen lang sein`)
	return /** @type {LocalizedString} */ (`Maximum length is ${i?.max} characters`)
});